import { t } from "i18next";
import { MDBBtn, MDBDatatable, MDBSpinner,MDBInput, MDBIcon, MDBAlert } from "mdb-react-ui-kit";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { getLiveDataRegisteredDevicesInDeviceMap } from "../../../apiclients/streamsapi_bridge";
import { useLocation } from "react-router";
import phoneImageActive from "../../../../src/components/images/Ip_Phone_icon.svg";
import appleImage from "../../../../src/components/images/Apple.svg";
import windowsImage from "../../../../src/components/images/Microsoft.svg";
import teamsImage from "../../../../src/components/images/teams.svg";
import androidImage from "../../../../src/components/images/Android.svg";
import iosImage from "../../../../src/components/images/iOS.svg";
import LaptopOrange from "../../../../src/components/images/laptop_orange.svg";
import mobilePhone from "../../../../src/components/images/Cell.svg";
import UIConstant from "../../../apiclients/UIConstant";
import { customSearch, useAutoFocusSearchAfterLoads } from "../../CustomSearchUtil/CustomSearch";
import { Tooltip } from "react-tooltip";



const OnlineDevices=()=>{

  const { t, i18n } = useTranslation();
  const location = useLocation();
  const stateData = location?.state;
  const [agentId, setAgentId] = useState(stateData?.selMember?.agentid ||JSON.parse(sessionStorage.getItem("admin_session")).logined_user || "" );
  const [deviceMapList, setdeviceMapList] = useState([]);
  const [isloading, setIsloading] = useState(false);
  const [searchValue,setsearchValue] = useState("");
  const [fullPhoneDetails, setFullPhoneDetails] = useState([]);
  const [currentUA, setCurrentUA] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipText, setTooltipText] = useState("Copy");

  const [dataLoaded, setDataLoaded] = useState(false);
  const searchRef = useRef(null);
  useAutoFocusSearchAfterLoads(dataLoaded, setDataLoaded, searchRef, true);


  const copyToClipboard = async (text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
            await navigator.clipboard.writeText(text);
            console.log("Copied:", text);
        } catch (err) {
            console.error("Failed to copy:", err);
        }
    } else {
        // fallback for insecure contexts
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        console.log("Copied with fallback:", text);
    }
    setTooltipText("Copied!");
    setShowTooltip(true)
};


  useEffect(()=>{
    getLiveApiDataDevicesInfo()
   
  },[])

  async function getLiveApiDataDevicesInfo() {
    try {
      console.log("getLiveApiDataDevicesInfo  node server request for List :");
      setIsloading(true);
      let apirespone = await getLiveDataRegisteredDevicesInDeviceMap(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        agentId
      );

      console.dir(apirespone);
      if (!apirespone.ok) {
        console.log(
          "Network response was not ok ! there might be some issue exist at api-server"
        );

        //throw new Error('Network response was not ok');
        // setData(datahard); //sample data to test in local network
      } else {
        if (apirespone.status == 200) {

          let responseData = await apirespone.json();
          let responseDevices = responseData.devices;
          let devices = [];
          responseDevices = responseDevices.parkData;
          responseDevices.forEach(element => {
            let json = {};
            json.device =
              <td>
                {element.device_type == 4 ? ( <img src={teamsImage} alt="Phone Active" /> )  :element.device_type === 1 ? ( <img src={phoneImageActive} alt="Phone Active" /> ) : element.device_type === 2 ? ( element.properties?.model?.toLowerCase()?.includes("mac") ? ( <img src={appleImage} alt="Apple Mac" /> ) : ( <img src={windowsImage} alt="Laptop Orange" /> ) ) : element.device_type === 3 && element.properties.model?.toLowerCase()?.includes("ios") ? ( <img src={iosImage} alt="Mobile Phone" /> ) : ( <img src={androidImage} alt="Default Laptop" /> ) }
              </td>
            json.phonename = element.properties.phonename;
            json.user = element.properties.username;
            json.designation = element.properties?.phone_designation == 1 ? "IP Phone 1" : element.properties?.phone_designation == 2 ? "IP Phone 2" : "Softphone";
            json.location = element.geometry.regionName;
            json.model =<div style={{ display: "flex", alignItems: "center", gap: "4px", whiteSpace: "nowrap" }}>
           <span>{ element.properties.mac_address == "Manual" ? element.properties.mac_address : element.properties.model}</span>
                <MDBIcon
                  fas
                  icon="info-circle"
                  style={{ fontSize: "12px", cursor: "pointer" }}
                  className="ps-2 table-icfo-icon table-info"
                  data-tooltip-id="tooltip-volume"
                  data-tooltip-content="custom"
                  onMouseEnter={() => setCurrentUA(element.user_agent)}   // <-- IMPORTANT
                />
          </div>;
            json.ipAdress = element.properties.mac_address;
            json.registeredip = element.properties.registeredIp;
            json.registerTo = element.pop;
            json.transport = element.properties.transport;
            json.software = (element.device_type == 2 || element.device_type == 3) ? element.properties.softeware_version : '-';
            devices.push(json);
          });
          setdeviceMapList(devices);
          setFullPhoneDetails(devices)
          console.log("devices ::::::::: " + JSON.stringify(devices));
          

        }
      }
    } catch (e) {
      console.log("Error in getLiveApiDataDevicesInfo :" + e);
    }
    setTimeout(() => {
      setIsloading(false);
      setDataLoaded(true);
    }, 2000);
  }

  const PhoneDetails = {
    columns: [
      { label: "", field: "device", sort: false },
      { label: "Phone Name", field: "phonename", sort: true },
      { label: "User", field: 'user' },
      //  { label: 'Extension', field: 'extention' },
      { label: 'Designation', field: 'designation' },
      { label: 'Location', field: 'location' },
      { label: 'Model', field: 'model' },
      { label: 'Mac Address', field: 'ipAdress' },
      { label: 'Registered IP', field: 'registeredip' },
      { label: 'Registered To', field: 'registerTo' },
      { label: 'Transport', field: 'transport' },
      { label: 'Software', field: 'software' },
    ],
    rows: deviceMapList,
  };

  const handleOnlineSearch = (searchValue) => {
    try {
      setsearchValue(searchValue);
      const filteredOnlineFeilds = customSearch(fullPhoneDetails, searchValue, UIConstant.ONLINELIST_FIELDS);
      setdeviceMapList(filteredOnlineFeilds);
    } catch (error) {
      console.log("[handleBlfSearch] Error" + error);
    }
  }

    return(
        <>
        <div className="mt-4 IpPhoneAndDevideTable">
            <div className='deviceMapDatatable'>
              <div class="actionbar"></div>
                <div className='mb-2 mt-3 position-relative w-auto'>
                <MDBInput label="Search" 
                 ref={searchRef}
                value={searchValue} 
                onChange={(e) => handleOnlineSearch(e.target.value)} />
                <MDBIcon fas icon="search" className='MDBDatatable-Search' />
            </div>
              <div className='deviceMapListDataTable'>
                <MDBDatatable
                  //search
                  sortField="Phone Name"
                  noFoundMessage={t("NotFoundMessage")}
                  data={PhoneDetails}
                  className="mt-2 actioncolumnbig"
                //   onRowClick={(event) => {
                //     showThisInf1(event);
                //   }}
                />
              </div>
            </div>
          </div>
          {isloading && (
        <div>
          <div className="loadingclass-popup"></div>
          <div className="popup-bg-loader loader_align">
            <MDBBtn disabled>
              <MDBSpinner
                size="sm"
                role="status"
                tag="span"
                className="me-2"
              />
              Loading...
            </MDBBtn>
          </div>
        </div>
      )}
         <Tooltip
        id="tooltip-volume"
        place="top"
        clickable
        className="exampleTooltipLight"
        render={() => (
          <div
            style={{ padding: "6px 10px", cursor: "pointer", userSelect: "none" }}
          >
            {currentUA}
            <MDBIcon far icon="copy" color="primary" size="1x" className="copyIcon me-2 ml-2 "
            onClick={() => copyToClipboard(currentUA)} />
          </div>
        )}
      />

        {showTooltip && (
                <MDBAlert
                    open
                    color="success"
                    autohide
                    className="alert-center"
                    position="bottom-right"
                    delay={2000}
                    onClose={() => setShowTooltip(false)}
                >
                    <MDBIcon far icon="check-circle" color="success" className="me-2" />

                    Copied to clipboard
                </MDBAlert>
            )}

        </>
    )
}

export default OnlineDevices